'use strict';

angular.module('atex.aceui.service').factory('TypeService',
['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

  function($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
    var serviceHandler = undefined;

    var handler = function() {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('TypeService').then(function(configuration) {
        var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'type');

        var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
        serviceHandler = atex.aceui.service.TypeService(serviceUrl, serviceSettings);

        return serviceHandler;
      });
    };

    return {
      /**
       * Retrieves typeDefinition data for a given type.
       * Wraps the request with an authentication guard.
       *
       * @param {string} typeName - Name of the type to get a typeDefinition for.
       *
       * @typedef {Object} TypeDefinition - An ace type definition.
       * @typedef {Object} TypeDefinitionResponse - An object containing the result from the TypeService
       * @property {TypeDefinition} typeDefinition
       *
       * @see atex.aceui.service.TypeService
       * @see AuthenticationService
       *
       * @returns {Promise.<TypeDefinitionResponse, atex.aceui.error.Error>}
       */
      getTypeDefinition: function (typeName) {
        return AuthenticationService.callWithAuthentication(function (currentUser) {
          return handler().then(function (serviceHandler) {
            return serviceHandler.getTypeDefinition({ typeName: typeName, authToken: currentUser.token });
          });
        });
      }
    };
  }
]);
